import { Grid } from '@mui/material';
import styled, { css } from 'styled-components';

export const ToggleContainer = styled(Grid)<{ withMargin: boolean }>`
	padding-top: 8px;
	justify-content: flex-start;
	align-items: center;

	${({ withMargin }) =>
		withMargin &&
		css`
			> *:nth-child(2) {
				margin-left: 8px;
			}
		`};
`;

export const Label = styled.h5`
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	color: rgba(0, 0, 0, 0.54);
	margin-top: 0rem;
	margin-bottom: 0;
	white-space: nowrap;
`;
